import * as React from "react"
import { Box } from "@mui/material";

import { DATE_PERIODS } from "@constants";
import {DateRangeBlock} from "@components";
import {rangeDatesMarketplacesLBBDetails} from "./Ranges";
import {evolutionChartCurrentPeriod} from "../@signals";


export default function LostBuyBoxEvolutionChartToolbar({dateRange, onChange}) {
    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={evolutionChartCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesMarketplacesLBBDetails}
            onChange={onChange}
            onOk = { () => evolutionChartCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
    </Box>
}


